import {
    RECEIVE_ABOUT_PBL_SUBPAGE,
    REQUEST_ABOUT_PBL_SUBPAGE,
    SET_ABOUT_PBL_SUBPAGE_ERROR,
    RECEIVE_ABOUT_PBL_EXAMPLES,
    REQUEST_ABOUT_PBL_EXAMPLES,
    SET_ABOUT_PBL_EXAMPLES_ERROR
  } from '../constants/ActionTypes';

const initialState = {
    isFetching: false,
    isLoadingError: false
};

export default function aboutPbl(state = initialState, action) {
    switch (action.type) {
        case SET_ABOUT_PBL_SUBPAGE_ERROR:
            return {
                ...state,
                isFetching: false,
                isLoadingError: true
            };
        case REQUEST_ABOUT_PBL_SUBPAGE:
            return {
                ...state,
                isFetching: true,
                isLoadingError: false
            };
        case RECEIVE_ABOUT_PBL_SUBPAGE:
            return {
                ...state,
                isFetching: false,
                pageData: Object.getPrototypeOf( action.data ) === Object.prototype ?
                              {
                                  ...action.data
                              }
                              : {
                                      data: action.data
                                }
            };
        case SET_ABOUT_PBL_EXAMPLES_ERROR:
            return {
                ...state,
                isFetching: false,
                isLoadingError: true
            };
        case REQUEST_ABOUT_PBL_EXAMPLES:
            return {
                ...state,
                isFetching: true,
                isLoadingError: false
            };
        case RECEIVE_ABOUT_PBL_EXAMPLES:
            return {
                ...state,
                isFetching: false,
                pageDataExamples: action.data
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/aboutPbl.js